import type { ReactNode } from "react";
import { cn } from "./ui";

/** Шапка раздела настроек: иконка, заголовок и пояснение — как в оригинале. */
export function PaneHead({ icon, title, text }: { icon: string; title: string; text: string }) {
  return (
    <div className="flex flex-wrap items-start gap-2.5">
      <span className="grid size-8 flex-none place-items-center rounded-btn bg-primary/10 text-primary" aria-hidden>
        <i className={cn(icon, "text-base leading-none")} />
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="text-base font-semibold leading-snug">{title}</h3>
        <p className="mt-1 max-w-2xl text-[12px] leading-relaxed text-muted-foreground">{text}</p>
      </div>
    </div>
  );
}

/** Переключатель в стиле остальных окон. */
export function Switch({ checked, onChange, label }: { checked: boolean; onChange: () => void; label: string }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={onChange}
      className={cn(
        "relative h-5 w-9 flex-none cursor-pointer rounded-full border transition",
        checked ? "border-primary bg-primary" : "border-border bg-foreground/10",
      )}
    >
      <span
        className={cn("absolute top-1/2 size-3.5 -translate-y-1/2 rounded-full bg-card transition-all", checked ? "start-[1.15rem]" : "start-[0.15rem]")}
        aria-hidden
      />
    </button>
  );
}

/** Небольшая подсказка под содержимым раздела. */
export function PaneNote({ children }: { children: ReactNode }) {
  return <p className="mt-3 text-[11px] leading-relaxed text-muted-foreground">{children}</p>;
}

/** Поле формы настроек с подписью. */
export function PaneField({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-[12px] font-medium text-muted-foreground">{label}</span>
      {children}
      {hint ? <span className="text-[10.5px] leading-relaxed text-muted-foreground">{hint}</span> : null}
    </label>
  );
}

export const SETTINGS_INPUT =
  "h-9 w-full box-border rounded-btn border border-border bg-background px-3 text-[12.5px] text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20";